const DOM = {};

DOM.nav = document.querySelector('.js-nav');
DOM.shape = DOM.nav.querySelector('svg.shape');
DOM.path = DOM.shape.querySelector('path');
DOM.enter = document.querySelector('.hamburger');
DOM.closeButton = document.querySelector('.js__close-nav');
DOM.shape.style.transformOrigin = '50% 0%';
const navOverlay = () => {
    let logo = scriptVars.logo.url;
    let logoAlt = scriptVars.logo.alt;
    let whiteLogo = scriptVars.white_logo.url;
    let whiteLogoAlt = scriptVars.white_logo.alt;
    let url = scriptVars.directory;
    let logoWrap = $('#nav-logo');
    let navButtonLight = $('.c-nav-overlay__button-book-light');
    let navButtonDark = $('.c-nav-overlay__button-book-dark');
    let closeButtonLight = $('.c-nav-overlay__close-light');
    let closeButtonDark = $('.c-nav-overlay__close-dark');

    if ($('.js-nav').length) {

        $('.js__hamburger').on('click', function (e) {
            e.preventDefault();
            closePopups();
            openNav();
            $('body').addClass('has-nav-overlay');
            // $('.js-nav').addClass('is-active');
        })

        $('.js__close-nav').on('click', function (e) {
            e.preventDefault();
            closeNav();
            closePopups();
            $('body').removeClass('has-nav-overlay');
            // $('.js-nav').removeClass('is-active');
        });


        //On load set the first menu image as active
        $('.image-menu li:first-child').addClass('active');

        //On hover of nav link
        $('.is-desktop .overlay-main-menu li.level-0 a').mouseenter(function () {
            $('.image-menu li').each(function(){
                $(this).removeClass('active');
            });

            //Update nav colours to match this link
            let menuItem = $(this).attr('title');
            let navColour = $(this).attr('data-bg');
            let textColour = $(this).attr('data-text');
            if (textColour == 'light') {
                navButtonLight.addClass('active');
                navButtonDark.removeClass('active');
                closeButtonLight.addClass('active');
                closeButtonDark.removeClass('active');
                $('.overlay-second-menu li a').addClass('light');
                $('.c-nav-overlay').addClass('light');
                logoWrap.hide().html('<img src="' + whiteLogo + '" alt="' + whiteLogoAlt + '">').fadeIn(300);
            }else{
                navButtonLight.removeClass('active');
                navButtonDark.addClass('active');
                closeButtonLight.removeClass('active');
                closeButtonDark.addClass('active');
                $('.overlay-second-menu li a').removeClass('light');
            }
            $('.c-nav-overlay__bg').css({backgroundColor: navColour});
            $('.c-nav-overlay .shape').css({fill: navColour});

            //Show the linked image
            $('.image-menu li#'+menuItem).addClass('active');
        });

        $('.is-desktop .overlay-main-menu li.level-0').mouseleave(function () {
            // //Reset to first menu image on hover off
            // $('.image-menu li').removeClass('active');
            // $('.image-menu li:first-child').addClass('active');

            // //Reset nav colour to first item
            // let navColour = $('.overlay-main-menu li:first-child a').attr('data-bg');
            // let textColour = $(this).attr('data-text');
            // navButton.css('color', navColour);
            // if (textColour == 'light') {
            //     $('.c-nav-overlay').removeClass('light');
            //     logoWrap.hide().html('<img src="' + logo + '" alt="' + logoAlt + '">').fadeIn(100);
            //     //closeNav.hide().html('<img src="' + url + '/library/images/icons/close-icon.svg" alt="close icon">').fadeIn(100);
            // }
            // $('.c-nav-overlay__bg').css({backgroundColor: navColour});
            // $('.c-nav-overlay .shape').css({fill: navColour});
        });

    }
}

const openNav = () => {
    DOM.nav = document.querySelector('.js-nav');
    DOM.shape = DOM.nav.querySelector('svg.shape');
    DOM.path = DOM.shape.querySelector('path');
    DOM.enter = document.querySelector('.hamburger');
    DOM.closeButton = document.querySelector('.js__close-nav');
    anime({
        targets: DOM.nav,
        duration: 1000,
        easing: 'easeInOutSine',
        translateY: 0,
    });

    anime({
        targets: DOM.shape,
        // delay: 800,
        scaleY: [
            {value:[0.3, 1.3], duration: 700,easing: 'easeInQuad'},
            {value:1, duration: 700,easing: 'easeOutQuad'}
        ],
    });

    anime({
        targets: DOM.path,
        duration: 700,
        // delay: 800,
        easing: 'easeOutQuad',
        d: DOM.path.getAttribute('pathdata:id')
    });

    let tl;
    tl = gsap.timeline({paused: true});

    tl.addLabel('start');

    tl.to('.c-header__logo', {autoAlpha: 0, duration: 0.3}, 'start');
    tl.to('.c-header__button', {autoAlpha: 0, duration: 0.3}, 'start');
    tl.to('.c-header__nav-wrap', {autoAlpha: 0, duration: 0.3}, 'start');

    tl.to($('.c-header__button-container'), {
        autoAlpha: 1, ease: Power1.easeOut, duration: 0.3
    }, '>-0.1');

    tl.from($('.overlay-main-menu .menu-item'), {
        autoAlpha: 0, y: 50, ease: Power1.easeOut, duration: 0.3, stagger: 0.1
    }, '>-0.25');

    tl.to('.c-nav-overlay__logo', {autoAlpha: 1, ease: Power1.easeOut, duration: 0.4}, '<0.25');
    tl.to('.c-nav-overlay__button-wrap', {autoAlpha: 1, ease: Power1.easeOut, duration: 0.4}, '<0.25');
    tl.to('.c-nav-overlay__mobile-button', {autoAlpha: 1, ease: Power1.easeOut, duration: 0.4}, '<0.25');
    tl.to('.c-nav-overlay__second-nav', {y: 0, autoAlpha: 1, ease: Power1.easeOut, duration: 0.4}, '<0.25');
    tl.to('.c-nav-overlay__images', {y: 0, autoAlpha: 1, ease: Power1.easeOut, duration: 0.4}, '<0.25');

    tl.play();

};

const closeNav = () => {
    DOM.nav = document.querySelector('.js-nav');
    DOM.shape = DOM.nav.querySelector('svg.shape');
    DOM.path = DOM.shape.querySelector('path');
    DOM.enter = document.querySelector('.hamburger');
    DOM.closeButton = document.querySelector('.js__close-nav');
    anime({
        targets: DOM.nav,
        delay: 400,
        duration: 800,
        easing: 'easeInOutSine',
        translateY: 'calc(-100vh - 320px)',
    });


    anime({
        targets: DOM.shape,
        delay: 800,
        scaleY: [
            {value:1.2, duration: 500,easing: 'easeOutQuad'},
            {value:[1, 0.5], duration: 500,easing: 'easeInQuad'},
        ],
    });

    anime({
        targets: DOM.path,
        delay: 800,
        duration: 500,
        easing: 'easeOutQuad',
        d: DOM.path.getAttribute('pathdata:id')
    });

    let tl;
    tl = gsap.timeline({paused: true});

    tl.addLabel('start');

    tl.to('.c-header__logo', {autoAlpha: 1, duration: 0.3}, 'start');
    tl.to('.c-header__button', {autoAlpha: 1, duration: 0.3}, 'start');
    tl.to('.c-header__nav-wrap', {autoAlpha: 1, duration: 0.3}, 'start');


    tl.play();

};